import { CloseButton, NextImage, noForwardProps } from '@apeiron/temp'
import AddIcon from '@mui/icons-material/Add'
import { Box, Button, styled, Typography } from '@mui/material'

const IconImage = styled(NextImage)`
  width: 16px;
  height: 16px;
`

const StyledButton = styled(Button, noForwardProps)<{ __isSelected?: boolean }>`
  border-radius: 4px;
  border: 1px solid
    ${props => (props.__isSelected ? 'transparent' : 'rgba(0, 0, 0, 0.4)')};
  background: ${props => (props.__isSelected ? '#E4C169' : '#565859')};
  column-gap: 4px;
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  min-width: 104px;
  text-align: left;
  justify-content: space-between;
  height: 34px;

  :hover,
  :active {
    background: ${props => (props.__isSelected ? '#E4C169' : '#676a6c')};
  }
`

const Label = styled(Typography, noForwardProps)<{ __isSelected?: boolean }>`
  color: ${props => (props.__isSelected ? '#000' : '#fff')};
  font-size: 12px;
  text-transform: none;
  font-weight: 300;
`

const ElementIconAndNameContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
  padding-left: 8px;
`

const StyledAddIcon = styled(AddIcon)`
  color: #ffffff;
  opacity: 0.5;
`

const StyledCloseButton = styled(CloseButton)`
  height: 24px;
  width: 24px;
  min-width: 24px;
  padding: 2px;

  svg {
    color: #ffffff;
  }
`

const SkillElementButton = ({
  iconUrl,
  label,
  onClick,
  disabled,
  onRemove,
  isSelected
}: Props) => {
  return (
    <StyledButton
      as={isSelected ? Box : undefined}
      onClick={onClick}
      __isSelected={isSelected}
      disabled={disabled}
    >
      <ElementIconAndNameContainer>
        <IconImage src={iconUrl} />
        <Label __isSelected={isSelected}>{label}</Label>
      </ElementIconAndNameContainer>
      {isSelected ? (
        <StyledCloseButton onClick={onRemove} />
      ) : (
        <StyledAddIcon />
      )}
    </StyledButton>
  )
}

type Props = {
  iconUrl: string
  label: string
  onClick?: () => void
  onRemove?: () => void
  isSelected?: boolean
  disabled?: boolean
}

export default SkillElementButton
